import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import roadMap from "../assets/roadmap.jpg";
import "./LevelMap.css";

const levels = [
  { id: 1, label: "Level 1", x: 12, y: 60, color: "#599bff" }, 
  { id: 2, label: "Level 2", x: 35, y: 25, color: "#ffa359" }, 
  { id: 3, label: "Level 3", x: 70, y: 65, color: "#e1abff" }, 
  { id: 4, label: "Level 4", x: 85, y: 25, color: "#599bff" }, 
];

const LevelMap = ({ startAt = 1 }) => {
  const navigate = useNavigate();
  const [unlockedLevel, setUnlockedLevel] = useState(startAt);

  useEffect(() => {
    const saved = localStorage.getItem("lastPlayedLevel");
    if (saved && !startAt) {
      setUnlockedLevel(parseInt(saved));
    }
  }, [startAt]);

  const handleLevelClick = (level) => {
    if (level <= unlockedLevel) {
      localStorage.setItem("lastPlayedLevel", level);
      navigate(`/level/${level}`);
    }
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="level-map-container">
      {/* Roadmap image */}
      <img src={roadMap} alt="Roadmap" className="roadmap-image" />

      <button onClick={handleBack} className="back-button">
        ← Back
      </button>
      <h1 className="level-map-title">Choose Level</h1>

      {levels.map((lvl) => (
        <div
          key={lvl.id}
          className={`level-marker ${
            lvl.id <= unlockedLevel ? "active" : "locked"
          }`}
          style={{
            position: "absolute",
            top: `${lvl.y}%`,
            left: `${lvl.x}%`,
            backgroundColor: lvl.id <= unlockedLevel ? lvl.color : undefined,
          }}
          onClick={() => handleLevelClick(lvl.id)}
        >
          {lvl.id}
        </div>
      ))}
    </div>
  );
};

export default LevelMap;
